import { useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";

/**
 * useLotDeepLink
 *
 * Parsea `?lotId=<uuid>` del hash de la URL al montar el componente.
 * Guarda el id en una ref (disponible de inmediato) y limpia el query param.
 *
 * Retorna `consumeLotId()`: devuelve el lotId una sola vez y luego null.
 * Llamar desde el onLoad del mapa para garantizar que la instancia está lista.
 */

function parseLotIdFromHash() {
  const hash = window.location.hash || '';
  const qIdx = hash.indexOf('?');
  if (qIdx === -1) return null;
  return new URLSearchParams(hash.substring(qIdx)).get('lotId') || null;
}

export function useLotDeepLink() {
  const navigate = useNavigate();
  const lotIdRef = useRef(parseLotIdFromHash());

  useEffect(() => {
    if (!lotIdRef.current) return;
    const cleanPath = (window.location.hash.split('?')[0] || '#/app').replace(/^#/, '');
    navigate(cleanPath, { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const consumeLotId = () => {
    const id = lotIdRef.current;
    lotIdRef.current = null;
    return id;
  };

  return { consumeLotId };
}
